import ObjectCache from './CacheService';
import UserAccount from '../UserAccount';
import DatabaseCollectionDocumentApi from '../server/DatabaseCollectionDocumentApi';
import DatabaseCollectionDocument from '../../models/databasecollectiondocument';

class DatabaseCollectionDocumentCache extends ObjectCache {
  api = DatabaseCollectionDocumentApi;
  createNew = () => new DatabaseCollectionDocument({});
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new DatabaseCollectionDocument(results);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}

const singleton = new DatabaseCollectionDocumentCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
